// /frontend/src/components/ProtectedRoute.js
import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { UserContext } from '../context/UserContext'

function ProtectedRoute({ children }) {
  const { user, loading } = useContext(UserContext)

  if (loading) return null // global spinner overlays everything

  // Not logged in (user is empty object)
  if (!user || (typeof user === 'object' && Object.keys(user).length === 0))
    return <Navigate to="/login" replace />

  return children
}

export default ProtectedRoute
